module.exports = __webpack_public_path__ + "static/media/logo192.318e10e5.png";